export interface CartValidationData {
  items: Array<{
    variant_id: number
    product_id: number
    is_preorder: boolean
  }>
  has_preorder: boolean
  has_regular: boolean
}

export function getCartValidationData(): CartValidationData | null {
  const dataElement = document.getElementById('cart-validation-data')
  if (!dataElement) return null

  try {
    return JSON.parse(dataElement.textContent || '{}')
  } catch (error) {
    console.error('Failed to parse cart validation data:', error)
    return null
  }
}

export function isPreorderProduct(form: HTMLFormElement): boolean {
  return form.dataset.isPreorder === 'true'
}

export function cartAlreadyHasPreorder(): boolean {
  const cartData = getCartValidationData()
  return !!cartData?.has_preorder
}

export function canAddToCart(isPreorder: boolean): boolean {
  const cartData = getCartValidationData()
  if (!cartData) return true
  if (cartData.items.length === 0) return true

  if (isPreorder && cartData.has_regular) return false
  if (!isPreorder && cartData.has_preorder) return false

  return true
}

export function cartIsMixed(): boolean {
  const cartData = getCartValidationData()
  return !!cartData?.has_preorder && !!cartData?.has_regular
}
